import Papa from 'papaparse';

type TDataItem = {
  id: string;
  [key: string]: string | number | (string | number)[];
};

export const downloadCSV = async (data: TDataItem[], header: string[]) => {
  if (!data.length) {
    return;
  }
  const csvContent = Papa.unparse([header, ...data.map((row) => Object.values(row))], {
    escapeFormulae: /^[=+\-@\t\r]/,
  });
  const a = document.createElement('a');
  if (URL && 'download' in a) {
    a.href = URL.createObjectURL(
      new Blob([csvContent], {
        type: 'text/csv;encoding:utf-8',
      }),
    );
    a.setAttribute('download', 'download.csv');
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } else {
    window.location.href = `data:application/octet-stream,${encodeURIComponent(csvContent)}`;
  }
};
